import { PagedResultGeneric, PagedSearch } from 'src/app/shared';
import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/api/api.service';

import { WebContentType } from '../../shared/model/webcontenttype.model';

@Injectable()
export class WebContentTypeService {
  private _apiService: ApiService;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  public getWebContentTypes(): Promise<PagedResultGeneric<WebContentType>> {
    let url = 'webcontenttypes';
    return this._apiService.get(url);
  }

  public searchWebContentTypes(searchParams: PagedSearch): Promise<PagedResultGeneric<WebContentType>> {
    let cacheOptions = this._apiService.getDefaultApiCacheOptionsForNoCache();
    let url = 'webcontenttypes';
    return this._apiService.getPaged(url, searchParams, cacheOptions);
  }

  public getWebContentType(webContentTypeId: number) {
    let url = `webcontenttype/${webContentTypeId}`;
    return this._apiService.get(url);
  }

  public upsertWebContentType(webContentType: WebContentType) {
    let url: string = '';
    url = '/webcontenttype/upsert';
    return this._apiService.post(url, webContentType).then(
      (data: string): Promise<string> => {
        return Promise.resolve(data);
      }
    );
  }

  public deleteEventType(ContentTypeID: number): Promise<void> {
    return this._apiService.delete(`webcontenttype/${ContentTypeID}`);
  }
}
